import React from "react";

import {
  QuerySearchUserResourcesArgs,
  Resource,
  SearchableResourceAggsInput,
} from "@examspark/types";

import { useSearch } from "../hooks/useSearch";

export type SearchResults = {
  aggregations?: {
    [key: string]: {
      key: string;
      count: number;
    }[];
  } | null;
  items: Resource[];
  nextToken?: string;
  total: number;
};

export type ArraySearchFields = {
  activity?: string[];
  alignmentIds?: string[];
  assetIds?: string[];
  assetType?: string[];
  assigneeId?: string[];
  bankId?: string[];
  blooms?: string[];
  contextIds?: string[];
  creatorId?: string[];
  dok?: string[];
  favoriteUserIds?: string[];
  fileExtension?: string[];
  fileMimetype?: string[];
  grade?: string[];
  interaction?: string[];
  keywords?: string[];
  language?: string[];
  maturity?: string[];
  objectiveAbbreviation?: string[];
  objectiveAuthority?: string[];
  objectiveId?: string[];
  objectiveScope?: string[];
  referencesIds?: string[];
  reviewerId?: string[];
  subject?: string[];
  type?: string[];
  watcherUserIds?: string[];
  workspaceId?: string[];
};

export type SearchFields = ArraySearchFields & {
  query?: string;
  name?: string;
  isArchived?: boolean;
  isDeleted?: boolean;
  limit?: number;
  /** Supersearch bar data
   * @todo add types to this */
  // search?: SearchData[];
  tag?: {
    key: string;
    value: string;
  }[];
  referencesIdsUnit?: string[];
  /**
   * Since our items/exams aren't linked to courses in our search index, we need
   * a way to filter content by the units in a course for the purpose of showing
   * facet counts, but we don't want it to take the place of `referencesIdsUnit`
   * which is the values the user has actually picked to filter on. */
  referencesIdsUnitCourseUnits?: string[];
};

export type SearchFieldsAndQuery = SearchFields & {
  aggs?: SearchableResourceAggsInput[];
  filter?: {
    query: string;
  };
};

export interface SearchState {
  variables: QuerySearchUserResourcesArgs;
  filter: SearchFields;
  limit?: number;
  dataChanged: number;
  resultsChanged: number;
  nextToken?: string;
}

export const defaultSearchState: SearchState = {
  variables: {},
  filter: {},
  dataChanged: 0,
  resultsChanged: 0,
};

export type SearchAction =
  | {
      type: "INITIAL";
      data: QuerySearchUserResourcesArgs;
    }
  | {
      type: "UPDATE";
      data: Partial<SearchFields>;
    }
  | {
      type: "TOGGLE_SELECT";
      field: keyof ArraySearchFields;
      value: string;
    }
  | {
      type: "RESET";
    }
  | {
      type: "NEXT_TOKEN";
      data: string;
    }
  | {
      type: "SET";
      data: SearchFields;
    }
  | {
      type: "DATA_CHANGED";
    };

const SearchContext = React.createContext<
  ReturnType<typeof useSearch> | undefined
>(undefined);

export default SearchContext;

export const searchReducer = (state: SearchState, action: SearchAction) => {
  state = { ...state };

  switch (action.type) {
    case "INITIAL":
      console.log("initial");
      state.variables = action.data;
      return state;
    case "RESET":
      state.filter = {};
      state.nextToken = undefined;
      state.dataChanged = Date.now();
      return state;
    case "UPDATE":
      if (!state.filter) state.filter = {};
      state.filter = Object.assign({}, state.filter, action.data);
      state.dataChanged = Date.now();
      state.nextToken = undefined;
      return state;
    case "NEXT_TOKEN":
      state.nextToken = action.data;
      return state;
    case "SET":
      state.filter = action.data;
      state.dataChanged = Date.now();
      state.nextToken = undefined;
      return state;
    case "DATA_CHANGED":
      state.dataChanged = Date.now();
      return state;
    default:
      return state;
  }
};
